var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navigator"}},[_c('div',[_c('BusinessDropdown',{ref:"businessDropdown",attrs:{"merchant":_vm.merchant,"no-hover":true,"button-style":_vm.BusinessDropdownTypes.NAVIGATION}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }